import ScriptType from "./ScriptType";
export default ScriptType